import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class Section extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
  };

  render = () => (
    <div className="row mt-3 align-items-center bbottom">
      {this.props.title && (
        <div className="col-sm-12">
          <h5>
            <b>{this.props.title}</b>
          </h5>
          <br />
        </div>
      )}
      <div className="col-sm-12 mb-3">{this.props.children}</div>
    </div>
  );
}



// WEBPACK FOOTER //
// src/modules/common/components/form/Section.js